<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>
    <Loader v-if="loading" />

    <!-- <div class="bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      <div
        class="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl"
      > -->
    <div
      v-else-if="data.length"
      class="bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8"
    >
      <DepartmentsSlider1 v-bind:departments="data" v-if="false" />

      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Кафедра
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Oпубликованных курсов
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="item in data" :key="item.id">
                    <td class="px-6 py-4 whitespace-nowrap">
                      <div class="flex items-center">
                        <div class="flex-shrink-0 h-10 w-10">
                          <img
                            class="h-10 w-10 rounded-full"
                            :src="item.image"
                            alt=""
                          />
                        </div>
                        <div class="ml-4">
                          <router-link
                            :to="{
                              name: 'department_show',
                              params: { id: item.id },
                            }"
                            class="text-sm font-medium text-gray-900"
                            >{{ item.name }}</router-link
                          >
                          <!-- <div class="text-sm text-gray-500">
                            jane.cooper@example.com
                          </div> -->
                        </div>
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-center">
                      <div class="text-sm text-gray-900">
                        {{ item.courseCount }}
                      </div>
                      <!-- <div class="text-sm text-gray-500">Optimization</div> -->
                    </td>
                  </tr>

                  <!-- More items... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import DepartmentsSlider1 from "@/components/DepartmentsSlider1";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "" },
      title: "Кафедры",
    };
  },
  async mounted() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("departments");
        this.data = response.data.departments;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },
  components: {
    Loader,
    PageTitle,
    DepartmentsSlider1,
  },
};
</script>


<style  scoped>
.custom-table {
  width: 100%;
  overflow: hidden;
  border-collapse: collapse;
  border-radius: 30px;
  border-radius: 10px;
  box-shadow: 0 0 2px 1px #e4e7eb;
}

.custom-table__col--10 {
  width: 10%;
}

.custom-table__col--25 {
  width: 25%;
}

.custom-table__col--50 {
  width: 50%;
}

.custom-table__col--75 {
  width: 75%;
}

.custom-table__header {
  border-radius: 10px;
  background-color: #f5f7fa;
}
.custom-table__header th {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 0.8rem;
  color: #166086;
}

.custom-table th,
.custom-table td {
  padding: 15px 20px;
  border-bottom: 1px solid hsl(214, 15%, 91%);
}

.custom-table__link {
  /* color: #0B4F71; */
}
.custom-table__button {
  width: 100%;
  color: #fff;
  background-color: #166086;
  padding: 6px 12px;
  border: none;
  border-radius: 10px;
}
</style>